/*  Below is a list of required multiple account participation tests
    Each test currently has variants Control / V1 / V2
        threeTierLanding page: Control variant displays multipleAccountsBenefit
        checkout: All variants displays multipleAccountsBenefit
        onboarding (secondary user journeys): All variants hide multipleAccountsBenefit */
const multipleAccountsParticipants = [
    'MULTIPLE_ACCOUNTS',
    'MULTIPLE_ACCOUNTS_UK',
    'MULTIPLE_ACCOUNTS_US',
    'MULTIPLE_ACCOUNTS_AU',
];
export const multipleAccountsBenefit = 'Three extra accounts to share';
const verifyParticipation = (participations, participationKey, variant) => {
    return participations[participationKey] === variant;
};
export const verifyMultipleAccountsParticipation = (participations, variant) => {
    return multipleAccountsParticipants.find((participantKey) => verifyParticipation(participations, participantKey, variant))
        ? variant
        : undefined;
};
